import React from 'react';

const SOSAnimalMessage = ({ objectData, locationAddress, coordinates }) => {

  const titleCaseAnimal = (animalString) => {
    return animalString.charAt(0).toUpperCase() + animalString.slice(1);
  };

  return (
    <div className="sosanimal-message">
      <p><b>Mensagem:</b> 
        {
          (objectData.animalData) ? 
          ` ${titleCaseAnimal(objectData.animalData.animal)} ${objectData.animalData.apparentAge} ${objectData.animalData.physicalCondition} encontrado por volta de ${locationAddress};
          coordenadas ${coordinates.latitude}, ${coordinates.longitude} (latitude, longitude).`
          : null
        }
      </p>
    </div>
  );
};

export default SOSAnimalMessage;
